import type { RouteLocationNormalizedGeneric } from 'vue-router'
import { i18n } from '@/plugins/i18n'

export default function useWebsite() {
  const title = useTitle()
  function setPageTitle(to: RouteLocationNormalizedGeneric) {
    title.value = to.meta.locale ? i18n.global.t(to.meta.locale) : import.meta.env.VITE_APP_STP_TITLE
  }

  return {
    setPageTitle,
  }
}
